<template>
    <div>
        <a-card size="small" title="socket推送历史V3">
        </a-card>
        <a-card size="small">
            <searchE @handleSearch="handleSubmit"></searchE>
            <tableE ref="templeteTableID"></tableE>
        </a-card>
    </div>
</template>
<script>
import tableE from './table'
import searchE from './search'


export default {
    data() {
        return {
            searchP:{
                keyword:'',
                passwaytype:'',
            }
        };
    },
    methods: {
        handleSubmit(searchP){
            this.searchP = searchP;
            this.$refs.templeteTableID.handleSearch(this.searchP);
        },

    },
    components:{
        tableE,
        searchE,
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
